$(document).ready(function(){
  if($('body').hasClass('template-collection')){
  
  $.fn.isInViewport = function() {
var elementTop = $(this).offset().top;
var elementBottom = elementTop + $(this).outerHeight();
var viewportTop = $(window).scrollTop();
var viewportBottom = viewportTop + $(window).height();
return elementBottom > viewportTop && elementTop < viewportBottom;
};
var flage=0;
 $(window).on('scroll', function() {
  if ($(".pagination").isInViewport() && flage==0 ) {
    flage=1;
  var link = $(".page.current").next().find('a').attr('href');
    if (typeof link !== 'undefined'){
    cusurl = location.protocol + '//' + location.host + link;
    //window.history.pushState({path:cusurl},'',cusurl);
    $(".cus-loading").addClass("cus-loading-activate");
     
    $.ajax({
    url: cusurl,
    type: 'GET',
    success: function(result){
    var newdata= $(result).find(".collection-product").html();
    $(".collection-product").append(newdata);
    var newdata1= $(result).find(".pagination").html();
    $(".pagination").html(newdata1);
    $(".cus-loading").removeClass("cus-loading-activate");
    flage=0;
      $('.product-tag').find('.active').trigger('click');
    },
    error: function (error) {
    flage=0;
    $(".cus-loading").removeClass("cus-loading-activate");
    }
    });
    }
  }
  });  
}
  if($(window).width() < 768){
    let announcementHeight = $('#announcement-bar').outerHeight();
     $('#SiteHeader').css('margin-top',announcementHeight+'px'); 
    $(window).on('resize', function(){
     let announcementHeight = $('#announcement-bar').outerHeight();
     $('#SiteHeader').css('margin-top',announcementHeight+'px');  
   });
  }
    
    $(document).on("change", ".cart-upsell-variant", function () {
      let option = this.options[this.selectedIndex];
      let card = $(this).closest(".upsell-product-inline");
      let comparePrice = option.getAttribute("data-compare-price");

      card.find(".upsellcart-add").attr("data-variant-id", option.value);
      card.find(".up-price-current").html(option.getAttribute("data-price"));
      card.find(".up-compare").html(comparePrice || "").toggleClass("hide", !comparePrice);
    });

    $(document).on("click",".upsell-add-btn .upsellcart-add", function (w) {
    w.preventDefault();
    
    let button = $(this);
    button.addClass("btn--loading");
    let variantId = parseInt($(this).attr("data-variant-id"));
    let productData = {
      id: variantId,
      quantity: 1,
    };
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: productData,
      dataType: "json",
      success: function (product) {
        document.dispatchEvent(new CustomEvent("cart:build"));
        $("body").trigger("added.ajaxProduct");
        button.removeClass("btn--loading");
      },
      error: function (error) {
        button.removeClass("btn--loading");
        console.log(error);
      },
    });
  }); 
  $(document).on('click','.close-item',function(){
     let key = $(this).attr("data-line-index");
     let productData = {
      'id': key,
      'quantity': 0,
    };
    
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: productData,
      dataType: "json",
      success: function (product) {
         document.dispatchEvent(new CustomEvent("cart:build"));
        $("body").trigger("added.ajaxProduct");
       
      },
      error: function (error) {
        console.log(error);
      },
    });
  });
  $('.scroll-smooth').on('click', function(event){     
    event.preventDefault();
  var height= $('.site-header.site-header--opening').outerHeight();
    if (height > 0) {
      $('html,body').animate({scrollTop:$(this.hash).offset().top - height }, 500);
    } else {
      $('html,body').animate({scrollTop:$(this.hash).offset().top}, 500);
    }
  });
});


$(document).on('click','.sticky-addToCart-flex a',function(){
  $('.payment-buttons button.add-to-cart').trigger('click');
});


$(window).scroll(function() {
  var heder_height = $('.site-header--opening').outerHeight();
  $('.product-sticky-addToCart').css('top',heder_height+'px');
  if($('.feature-product-template').length != 0){
    var top_of_element = $('.feature-product-template').offset().top;
    var bottom_of_element = $('.feature-product-template').offset().top + $('.feature-product-template').outerHeight();
    var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    var top_of_screen = $(window).scrollTop();
    if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
         $('.product-sticky-addToCart').fadeOut();;
    } else {
        $('.product-sticky-addToCart').fadeIn();
    }
  }
});

var findSelectedVariant = function() {
  var sellingPlanContainer = document.querySelector('.appstle_stand_alone_selector');
  if(document.querySelector('.appstle_stand_alone_selector') != null){
    let selectedVariant;
     if(sellingPlanContainer != null){
      if(sellingPlanContainer.getAttribute('data-product-data') != ''){
        var product = JSON.parse(sellingPlanContainer.getAttribute('data-product-data'));
        var selectedVariantId = document.querySelector('.get-variant-id').getAttribute('variantid');
        selectedVariantId = parseInt(selectedVariantId);
        
        if(product != null){
          var productVariant = product.variants;
          for (var i = 0; i < productVariant.length; i++) {
            // console.log(productVariant[i]);
            // console.log(selectedVariantId);
            if (productVariant[i].id === selectedVariantId) {
              selectedVariant = productVariant[i];
            }
          }
        
          var default_data = selectedVariant.selling_plan_allocations;
          var saving_price = default_data[0].compare_at_price - default_data[0].price;
        
          $('.payment-buttons .current-variant-price').html('<span class="money">'+theme.Currency.formatMoney(default_data[0].price, theme.settings.moneyFormat)+'</span>');
          $('.sticky-atc-cuurent-price').html('<span class="money">'+theme.Currency.formatMoney(default_data[0].price, theme.settings.moneyFormat)+'</span>');
          $('.appstle-saving-price span').html('<span class="money">'+theme.Currency.formatMoney(saving_price, theme.settings.moneyFormat)+'</span>');
        } 
      }
     }
    return selectedVariant;
  }
}

 setTimeout(function() {
  findSelectedVariant();
 }, 1000);

// var productForm = document.querySelector('.product-single__form')
// productForm.addEventListener('change', function() {
//   var selectedVariant_2 = findSelectedVariant();
//   var availableSellingPlanAllocations = selectedVariant_2.selling_plan_allocations;
//   var saving_price = availableSellingPlanAllocations[0].compare_at_price - availableSellingPlanAllocations[0].price;
//   $('.appstle-saving-price span').html('<span class="money">'+theme.Currency.formatMoney(saving_price, theme.settings.moneyFormat)+'</span>');
// });


$(document).on('click','.appstle_radio_label',function(){
  var _this = $(this).closest('.appstle_subscription_wrapper_option');
  var current_val = $(this).next().find('.appstle_subscription_amount').html();
  setTimeout(function() {
    $('.payment-buttons .current-variant-price').html(current_val);
    $('.sticky-atc-cuurent-price').html(current_val);
  }, 500);
  if (_this.hasClass('appstle_include_dropdown')){
    $('.appstle-saving-price').show();
  } else {
    $('.appstle-saving-price').hide();
  }
});

// Code By KAKA
(function() {
  // === CONFIGURATION ===
  // Set your desired account link URL here:
  const DESIRED_ACCOUNT_URL = '/account/login';
  // If you want logged-in users to go somewhere else, set it here:
  // const DESIRED_ACCOUNT_URL = '/account';

  function restoreAccountLinks() {
    // Find all links that the K-Hub script has hijacked to '#k-hub'
    const hijackedLinks = document.querySelectorAll('a[href="#k-hub"]');

    hijackedLinks.forEach(function(link) {
      link.href = DESIRED_ACCOUNT_URL;

      // Remove the transition-skip classes the K-Hub script added
      link.classList.remove('no-transition', 'js-no-transition');

      // Mark as restored so we can track it / avoid redundant work
      link.setAttribute('data-k-hub-ignore', 'true');
      link.setAttribute('data-restored', 'true');
    });

    if (hijackedLinks.length > 0) {
      console.log('[Account Link Restore] Restored ' + hijackedLinks.length + ' hijacked link(s).');
    }
  }

  // --- 1. Run immediately in case K-Hub already ran ---
  restoreAccountLinks();

  // --- 2. Run on readystatechange (same timing as K-Hub, but we load AFTER it) ---
  if (document.readyState !== 'complete') {
    document.addEventListener('readystatechange', function() {
      restoreAccountLinks();
    });
  }

  // --- 3. Run on DOMContentLoaded and load as extra safety nets ---
  document.addEventListener('DOMContentLoaded', restoreAccountLinks);
  window.addEventListener('load', restoreAccountLinks);

  // --- 4. MutationObserver: catch ANY future replacements (e.g., K-Hub re-runs, SPA navigations) ---
  const observer = new MutationObserver(function(mutations) {
    let needsRestore = false;

    for (const mutation of mutations) {
      // Check if any added nodes or attribute changes result in '#k-hub' links
      if (mutation.type === 'attributes' && mutation.attributeName === 'href') {
        if (mutation.target.getAttribute('href') === '#k-hub') {
          needsRestore = true;
          break;
        }
      }
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (
              (node.tagName === 'A' && node.getAttribute('href') === '#k-hub') ||
              node.querySelector?.('a[href="#k-hub"]')
            ) {
              needsRestore = true;
              break;
            }
          }
        }
        if (needsRestore) break;
      }
    }

    if (needsRestore) {
      restoreAccountLinks();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href'],
  });

  // --- 5. Periodic fallback (covers edge cases like deferred scripts) ---
  let checks = 0;
  const maxChecks = 20;
  const interval = setInterval(function() {
    restoreAccountLinks();
    checks++;
    if (checks >= maxChecks) {
      clearInterval(interval);
    }
  }, 500); // Runs every 500ms for 10 seconds, then stops

})();
